<div class="modal">
  <i class="fal fa-times modal__close"
     (click)="close()"></i>
  <app-create-contact-attempt [entityId]="data.entityId"
                              [campaignId]="data.campaignId"
                              [initiallySelectedContactItem]="data.contactItem"
                              (closeModal)="close()">
  </app-create-contact-attempt>
</div>
